import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { QRCodeSVG } from 'qrcode.react';

import { Box, Button, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

import CenteredWrapper from 'components/wrappers/CenteredWrapper';

import { checkNumbers, required, numbers, composeValidators } from 'validators/validationInputFields';

import TextField from 'inputs/forms/TextField';

const QR_SIZE = 168;

const styles = () => ({
    secret: {
        wordBreak: 'break-all',
        fontFamily: 'monospace',
    },
});

const MfaSetup = props => {
    const handleKeyPress = useCallback(event => {
        if (!checkNumbers(event.key)) {
            event.preventDefault();
        }
    }, []);

    return (
        <CenteredWrapper>
            <Box my={2} textAlign="center">
                <Typography variant="h1">
                    {l('Set up two-step verification')}
                </Typography>
            </Box>
            <Box px={12} mb={2}>
                <Typography>
                    {l('Scan this code with an authenticator app, then enter the code it shows.')}
                </Typography>
            </Box>
            {props.otpAuthUri && (
                <Box mb={2} display="flex" justifyContent="center">
                    <QRCodeSVG value={props.otpAuthUri} size={QR_SIZE} />
                </Box>
            )}
            <Box px={12} mb={2}>
                <Typography variant="body2">
                    {l('Cannot scan it? Enter this key instead:')}
                </Typography>
                <Typography variant="body2" className={props.classes.secret}>
                    {props.secretCode}
                </Typography>
            </Box>
            <Box mt={2}>
                <Form onSubmit={props.onClickConfirm}>
                    {({ submitError, submitting, handleSubmit }) => (
                        <form onSubmit={handleSubmit}>
                            <Box px={12} mb={4}>
                                <Field
                                    fullWidth
                                    name="code"
                                    innerError={submitError || null}
                                    validate={composeValidators(required, numbers)}
                                    placeholder={l('Enter your code')}
                                    component={TextField}
                                    onKeyPress={handleKeyPress}
                                />
                            </Box>
                            <Box px={12} mt={4}>
                                <Button
                                    fullWidth
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    disabled={submitting}
                                >
                                    {l('Confirm')}
                                </Button>
                            </Box>
                            <Box px={12} mt={2}>
                                <Button
                                    fullWidth
                                    color="primary"
                                    disabled={submitting}
                                    onClick={props.onClickCancel}
                                >
                                    {l('Cancel')}
                                </Button>
                            </Box>
                        </form>
                    )}
                </Form>
            </Box>
        </CenteredWrapper>
    );
};

MfaSetup.propTypes = {
    secretCode: PropTypes.string,
    otpAuthUri: PropTypes.string,
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    onClickCancel: PropTypes.func.isRequired,
    onClickConfirm: PropTypes.func.isRequired,
};

export default withStyles(styles)(MfaSetup);
